import { useContext } from 'react'

import { AnalyticsContext } from '../context/index'

export const useAnalytics = () => {
    return useContext(AnalyticsContext)
}
